import { gql } from "@apollo/client";

export const GET_VEHICLE_AVAILABILITY = gql`
  query getTestDriveVehicleAvailability(
    $availabilityParams: TestDriveVehicleAvailability
  ) {
    getTestDriveVehicleAvailability(availabilityParams: $availabilityParams) {
      dropoffQueryDate
      pickupQueryDate
      isExtended
      dropoffSlots {
        driverSlotsExist
        timeSlots {
          timeSlot
          vehicleId
          driverId
          slotId
        }
      }
      pickupSlots {
        driverSlotsExist
        timeSlots {
          timeSlot
          vehicleId
          driverId
          slotId
        }
      }
    }
  }
`;
